import { Form } from 'antd';
import { FormItemProps } from 'antd/lib/form/FormItem';
import styled from 'styled-components';

import { colors } from 'assets/styles/commonStyle';

interface CustomFormItemProps extends FormItemProps {
  margin?: string;
}

const StyledFormItem = styled(Form.Item).attrs<CustomFormItemProps>(props => ({
  labelAlign: props.labelAlign ?? 'left',
  labelCol: props.labelCol ?? { xs: 24 },
  wrapperCol: props.wrapperCol ?? { xs: 24 }
}))<CustomFormItemProps>`
  &&& {
    margin: ${({ margin }) => (margin ? margin : '')};

    .ant-form-item-label {
      white-space: normal;
      color: ${colors.colorGrayDark};
      font-weight: 500;
      label {
        display: block;
        margin-right: 8px;
        line-height: 22px;
        &::after {
          content: none;
        }

        @media (min-width: 1600px) {
          padding-top: 8px;
        }
      }
      &:after {
        content: none !important;
      }
    }
  }
`;

// Defaults: labelAlign='left', labelCol={{ xs: 24 }}, wrapperCol={{ xs: 24 }}.
// Override per usage if needed.
export default StyledFormItem;
